var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "change-log mt-4" }, [
    !_vm.isDataLoaded
      ? _c("div", { staticClass: "popup" }, [_c("eas-loader")], 1)
      : _c(
          "div",
          [
            _c("content-wrapper", {
              scopedSlots: _vm._u([
                {
                  key: "filters",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "change-log-filter" }, [
                        _c(
                          "div",
                          { staticClass: "flex-row changeLog-filter" },
                          [
                            _c("div", { staticClass: "flex-col" }, [
                              _c("div", { staticClass: "flex-row" }, [
                                _c(
                                  "div",
                                  _vm._g(
                                    {
                                      staticClass: "flex-col pt-1 pb-2 filter",
                                    },
                                    _vm.hideDateFilter()
                                  ),
                                  [
                                    _c(
                                      "a",
                                      {
                                        class: {
                                          active:
                                            _vm.filterItem.dateItem.isActive,
                                        },
                                        attrs: { href: "javascript:void(0)" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleDateFilter()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("filterByDate")) +
                                            " "
                                        ),
                                        _vm.filterFromDateTimezone ||
                                        _vm.filterToDateTimezone
                                          ? _c("span", [
                                              _vm._v(" ( "),
                                              _vm.filterFromDateTimezone
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dateLabelFunction(
                                                          _vm.filterFromDateTimezone
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm.filterFromDateTimezone &&
                                              _vm.filterToDateTimezone
                                                ? _c("span", [_vm._v(" - ")])
                                                : _vm._e(),
                                              _vm.filterToDateTimezone
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dateLabelFunction(
                                                          _vm.filterToDateTimezone
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" ) "),
                                            ])
                                          : _vm._e(),
                                        _c("img", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !_vm.filterItem.dateItem
                                                  .isActive,
                                              expression:
                                                "!filterItem.dateItem.isActive",
                                            },
                                          ],
                                          class: [
                                            "triangle ml-1",
                                            {
                                              up: _vm.filterItem.dateItem
                                                .isExpanded,
                                            },
                                          ],
                                          attrs: {
                                            src: require("@/assets/icons/ic-triangle-dropdown@2x.png"),
                                          },
                                        }),
                                        _c("img", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.filterItem.dateItem
                                                  .isActive,
                                              expression:
                                                "filterItem.dateItem.isActive",
                                            },
                                          ],
                                          class: [
                                            "triangle ml-1",
                                            {
                                              up: _vm.filterItem.dateItem
                                                .isExpanded,
                                            },
                                          ],
                                          attrs: {
                                            src: require("@/assets/icons/ic-triangle-dropdown-dark@2x.png"),
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "fade-transition",
                                      { attrs: { fast: true } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.filterItem.dateItem
                                                    .isExpanded,
                                                expression:
                                                  "filterItem.dateItem.isExpanded",
                                              },
                                            ],
                                            staticClass: "filter-expand",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "close-button",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.closeDateFilter()
                                                  },
                                                },
                                              },
                                              [_vm._v("×")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "flex-row" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-col mr-3 mt-1",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "1.5rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("dateFrom")
                                                          ) + ":"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("datetime-picker", {
                                                      staticClass:
                                                        "changelog-filter-datepicker",
                                                      attrs: {
                                                        type: "date",
                                                        lang: "en",
                                                        inline: true,
                                                        format: "YYYY-MM-DD",
                                                        "disabled-date":
                                                          _vm.disabledDates,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.onDateChange(
                                                            true
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.filterFromDateTimezone,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.filterFromDateTimezone =
                                                            $$v
                                                        },
                                                        expression:
                                                          "filterFromDateTimezone",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-col mt-1",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "1.5rem",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("dateTo")
                                                          ) + ":"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("datetime-picker", {
                                                      staticClass:
                                                        "changelog-filter-datepicker",
                                                      attrs: {
                                                        type: "date",
                                                        lang: "en",
                                                        inline: true,
                                                        format: "YYYY-MM-DD",
                                                        "disabled-date":
                                                          _vm.disabledDates,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.onDateChange(
                                                            false
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.filterToDateTimezone,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.filterToDateTimezone =
                                                            $$v
                                                        },
                                                        expression:
                                                          "filterToDateTimezone",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-row apply-container",
                                              },
                                              [
                                                _c(
                                                  "adam-button",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        !_vm.filterFromDateTimezone &&
                                                        !_vm.filterToDateTimezone,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.clear()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("clear"))
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "adam-button",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.apply()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("apply"))
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("span", {
                                  staticClass: "separator ml-1 mr-1",
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.hideTypeFilter,
                                        expression: "hideTypeFilter",
                                      },
                                    ],
                                    staticClass: "flex-col pt-1 pb-2 filter",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        class: {
                                          active:
                                            _vm.filterItem.plantItem.isActive,
                                        },
                                        attrs: { href: "javascript:void(0)" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleTypeFilter()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("filterByPlant")) +
                                            " "
                                        ),
                                        _c("img", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !_vm.filterItem.plantItem
                                                  .isActive,
                                              expression:
                                                "!filterItem.plantItem.isActive",
                                            },
                                          ],
                                          class: [
                                            "triangle ml-1",
                                            {
                                              up: _vm.filterItem.plantItem
                                                .isExpanded,
                                            },
                                          ],
                                          attrs: {
                                            src: require("@/assets/icons/ic-triangle-dropdown@2x.png"),
                                          },
                                        }),
                                        _c("img", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.filterItem.plantItem
                                                  .isActive,
                                              expression:
                                                "filterItem.plantItem.isActive",
                                            },
                                          ],
                                          class: [
                                            "triangle ml-1",
                                            {
                                              up: _vm.filterItem.plantItem
                                                .isExpanded,
                                            },
                                          ],
                                          attrs: {
                                            src: require("@/assets/icons/ic-triangle-dropdown-dark@2x.png"),
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "fade-transition",
                                      { attrs: { fast: true } },
                                      [
                                        _vm.filterItem.plantItem.isExpanded
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "filter-expand filter-expand--type",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "search-filter",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.filterItem
                                                              .plantItem.search,
                                                          expression:
                                                            "filterItem.plantItem.search",
                                                        },
                                                      ],
                                                      staticClass: "search",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder:
                                                          _vm.$t("plant/unit"),
                                                        "max-length": "100",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.filterItem
                                                            .plantItem.search,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.filterItem
                                                              .plantItem,
                                                            "search",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c("font-awesome-icon", {
                                                      staticClass:
                                                        "search-icon fa-2x",
                                                      attrs: {
                                                        icon: ["fas", "search"],
                                                      },
                                                    }),
                                                    _c(
                                                      "button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.filterItem
                                                                .plantItem
                                                                .search !== "",
                                                            expression:
                                                              "filterItem.plantItem.search !== ''",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "clear-search",
                                                        on: {
                                                          click: () =>
                                                            (_vm.filterItem.plantItem.search =
                                                              ""),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "clear",
                                                            attrs: {
                                                              icon: [
                                                                "fas",
                                                                "times",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "checkboxFilter",
                                                  },
                                                  [
                                                    !_vm.filteredPlants.length
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "empty-list",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "noItemsMatched"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.filterItem.plantItem
                                                          .showSelectAll
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "checkbox-container",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .filterItem
                                                                      .plantItem
                                                                      .isCheckAll,
                                                                  expression:
                                                                    "filterItem.plantItem.isCheckAll",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "checkbox",
                                                              },
                                                              domProps: {
                                                                checked:
                                                                  Array.isArray(
                                                                    _vm
                                                                      .filterItem
                                                                      .plantItem
                                                                      .isCheckAll
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm
                                                                          .filterItem
                                                                          .plantItem
                                                                          .isCheckAll,
                                                                        null
                                                                      ) > -1
                                                                    : _vm
                                                                        .filterItem
                                                                        .plantItem
                                                                        .isCheckAll,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.checkAllPlants()
                                                                  },
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm
                                                                          .filterItem
                                                                          .plantItem
                                                                          .isCheckAll,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          null,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .plantItem,
                                                                            "isCheckAll",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .plantItem,
                                                                            "isCheckAll",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .filterItem
                                                                          .plantItem,
                                                                        "isCheckAll",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "selectAll"
                                                                )
                                                              ) + " "
                                                            ),
                                                            _c("span", {
                                                              staticClass:
                                                                "checkmark",
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._l(
                                                      _vm.filteredPlants,
                                                      function (plant) {
                                                        return _c(
                                                          "label",
                                                          {
                                                            key: plant.id,
                                                            staticClass:
                                                              "checkbox-container",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .filterItem
                                                                      .plantItem
                                                                      .checkedList,
                                                                  expression:
                                                                    "filterItem.plantItem.checkedList",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "checkbox",
                                                              },
                                                              domProps: {
                                                                value: plant.id,
                                                                checked:
                                                                  Array.isArray(
                                                                    _vm
                                                                      .filterItem
                                                                      .plantItem
                                                                      .checkedList
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm
                                                                          .filterItem
                                                                          .plantItem
                                                                          .checkedList,
                                                                        plant.id
                                                                      ) > -1
                                                                    : _vm
                                                                        .filterItem
                                                                        .plantItem
                                                                        .checkedList,
                                                              },
                                                              on: {
                                                                change: [
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm
                                                                          .filterItem
                                                                          .plantItem
                                                                          .checkedList,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          plant.id,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .plantItem,
                                                                            "checkedList",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .plantItem,
                                                                            "checkedList",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .filterItem
                                                                          .plantItem,
                                                                        "checkedList",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateCheckallPlants()
                                                                  },
                                                                ],
                                                              },
                                                            }),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  plant.name
                                                                ) +
                                                                " "
                                                            ),
                                                            _c("span", {
                                                              staticClass:
                                                                "checkmark",
                                                            }),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "done-filter-button mt-1",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.filterPlantChange()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.$t("done")) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("span", {
                                  staticClass: "separator ml-1 mr-1",
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.hideUserFilter,
                                        expression: "hideUserFilter",
                                      },
                                    ],
                                    staticClass: "flex-col pt-1 pb-2 filter",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        class: {
                                          active:
                                            _vm.filterItem.userItem.isActive,
                                        },
                                        attrs: { href: "javascript:void(0)" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleUserFilter()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("filterByUser")) +
                                            " "
                                        ),
                                        _c("img", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !_vm.filterItem.userItem
                                                  .isActive,
                                              expression:
                                                "!filterItem.userItem.isActive",
                                            },
                                          ],
                                          class: [
                                            "triangle ml-1",
                                            {
                                              up: _vm.filterItem.userItem
                                                .isExpanded,
                                            },
                                          ],
                                          attrs: {
                                            src: require("@/assets/icons/ic-triangle-dropdown@2x.png"),
                                          },
                                        }),
                                        _c("img", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.filterItem.userItem
                                                  .isActive,
                                              expression:
                                                "filterItem.userItem.isActive",
                                            },
                                          ],
                                          class: [
                                            "triangle ml-1",
                                            {
                                              up: _vm.filterItem.userItem
                                                .isExpanded,
                                            },
                                          ],
                                          attrs: {
                                            src: require("@/assets/icons/ic-triangle-dropdown-dark@2x.png"),
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "fade-transition",
                                      { attrs: { fast: true } },
                                      [
                                        _vm.filterItem.userItem.isExpanded
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "filter-expand filter-expand--type",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "search-filter",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.filterItem
                                                              .userItem.search,
                                                          expression:
                                                            "filterItem.userItem.search",
                                                        },
                                                      ],
                                                      staticClass: "search",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder:
                                                          _vm.$t("user"),
                                                        "max-length": "100",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.filterItem
                                                            .userItem.search,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.filterItem
                                                              .userItem,
                                                            "search",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c("font-awesome-icon", {
                                                      staticClass:
                                                        "search-icon fa-2x",
                                                      attrs: {
                                                        icon: ["fas", "search"],
                                                      },
                                                    }),
                                                    _c(
                                                      "button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.filterItem
                                                                .userItem
                                                                .search !== "",
                                                            expression:
                                                              "filterItem.userItem.search !== ''",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "clear-search",
                                                        on: {
                                                          click: () =>
                                                            (_vm.filterItem.userItem.search =
                                                              ""),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "clear",
                                                            attrs: {
                                                              icon: [
                                                                "fas",
                                                                "times",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "checkboxFilter",
                                                  },
                                                  [
                                                    !_vm.filteredUsers.length
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "empty-list",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "noItemsMatched"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.filterItem.userItem
                                                          .showSelectAll
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "checkbox-container",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .filterItem
                                                                      .userItem
                                                                      .isCheckAll,
                                                                  expression:
                                                                    "filterItem.userItem.isCheckAll",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "checkbox",
                                                              },
                                                              domProps: {
                                                                checked:
                                                                  Array.isArray(
                                                                    _vm
                                                                      .filterItem
                                                                      .userItem
                                                                      .isCheckAll
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm
                                                                          .filterItem
                                                                          .userItem
                                                                          .isCheckAll,
                                                                        null
                                                                      ) > -1
                                                                    : _vm
                                                                        .filterItem
                                                                        .userItem
                                                                        .isCheckAll,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.checkAllUsers()
                                                                  },
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm
                                                                          .filterItem
                                                                          .userItem
                                                                          .isCheckAll,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          null,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .userItem,
                                                                            "isCheckAll",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .userItem,
                                                                            "isCheckAll",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .filterItem
                                                                          .userItem,
                                                                        "isCheckAll",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "selectAll"
                                                                )
                                                              ) + " "
                                                            ),
                                                            _c("span", {
                                                              staticClass:
                                                                "checkmark",
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._l(
                                                      _vm.filteredUsers,
                                                      function (user, i) {
                                                        return _c(
                                                          "label",
                                                          {
                                                            key: i,
                                                            staticClass:
                                                              "checkbox-container",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .filterItem
                                                                      .userItem
                                                                      .checkedList,
                                                                  expression:
                                                                    "filterItem.userItem.checkedList",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "checkbox",
                                                              },
                                                              domProps: {
                                                                value: user,
                                                                checked:
                                                                  Array.isArray(
                                                                    _vm
                                                                      .filterItem
                                                                      .userItem
                                                                      .checkedList
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm
                                                                          .filterItem
                                                                          .userItem
                                                                          .checkedList,
                                                                        user
                                                                      ) > -1
                                                                    : _vm
                                                                        .filterItem
                                                                        .userItem
                                                                        .checkedList,
                                                              },
                                                              on: {
                                                                change: [
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm
                                                                          .filterItem
                                                                          .userItem
                                                                          .checkedList,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          user,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .userItem,
                                                                            "checkedList",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .userItem,
                                                                            "checkedList",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .filterItem
                                                                          .userItem,
                                                                        "checkedList",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateCheckallUsers()
                                                                  },
                                                                ],
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(user) + " "
                                                            ),
                                                            _c("span", {
                                                              staticClass:
                                                                "checkmark",
                                                            }),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "done-filter-button mt-1",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.filterUserChange()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.$t("done")) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("span", {
                                  staticClass: "separator ml-1 mr-1",
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.hideItemFilter,
                                        expression: "hideItemFilter",
                                      },
                                    ],
                                    staticClass: "flex-col pt-1 pb-2 filter",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        class: {
                                          active:
                                            _vm.filterItem.changedItem.isActive,
                                        },
                                        attrs: { href: "javascript:void(0)" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleChangedItemFilter()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("filterByChangedItem")
                                            ) +
                                            " "
                                        ),
                                        _c("img", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                !_vm.filterItem.changedItem
                                                  .isActive,
                                              expression:
                                                "!filterItem.changedItem.isActive",
                                            },
                                          ],
                                          class: [
                                            "triangle ml-1",
                                            {
                                              up: _vm.filterItem.changedItem
                                                .isExpanded,
                                            },
                                          ],
                                          attrs: {
                                            src: require("@/assets/icons/ic-triangle-dropdown@2x.png"),
                                          },
                                        }),
                                        _c("img", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.filterItem.changedItem
                                                  .isActive,
                                              expression:
                                                "filterItem.changedItem.isActive",
                                            },
                                          ],
                                          class: [
                                            "triangle ml-1",
                                            {
                                              up: _vm.filterItem.changedItem
                                                .isExpanded,
                                            },
                                          ],
                                          attrs: {
                                            src: require("@/assets/icons/ic-triangle-dropdown-dark@2x.png"),
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "fade-transition",
                                      { attrs: { fast: true } },
                                      [
                                        _vm.filterItem.changedItem.isExpanded
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "filter-expand filter-expand--type",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "search-filter",
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.filterItem
                                                              .changedItem
                                                              .search,
                                                          expression:
                                                            "filterItem.changedItem.search",
                                                        },
                                                      ],
                                                      staticClass: "search",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder:
                                                          _vm.$t("changedItem"),
                                                        "max-length": "100",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.filterItem
                                                            .changedItem.search,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            _vm.filterItem
                                                              .changedItem,
                                                            "search",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c("font-awesome-icon", {
                                                      staticClass:
                                                        "search-icon fa-2x",
                                                      attrs: {
                                                        icon: ["fas", "search"],
                                                      },
                                                    }),
                                                    _c(
                                                      "button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.filterItem
                                                                .changedItem
                                                                .search !== "",
                                                            expression:
                                                              "filterItem.changedItem.search !== ''",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "clear-search",
                                                        on: {
                                                          click: () =>
                                                            (_vm.filterItem.changedItem.search =
                                                              ""),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "clear",
                                                            attrs: {
                                                              icon: [
                                                                "fas",
                                                                "times",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "checkboxFilter",
                                                  },
                                                  [
                                                    !_vm.filteredItems.length
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "empty-list",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "noItemsMatched"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.filterItem
                                                          .changedItem
                                                          .showSelectAll
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "checkbox-container",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .filterItem
                                                                      .changedItem
                                                                      .isCheckAll,
                                                                  expression:
                                                                    "filterItem.changedItem.isCheckAll",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "checkbox",
                                                              },
                                                              domProps: {
                                                                checked:
                                                                  Array.isArray(
                                                                    _vm
                                                                      .filterItem
                                                                      .changedItem
                                                                      .isCheckAll
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm
                                                                          .filterItem
                                                                          .changedItem
                                                                          .isCheckAll,
                                                                        null
                                                                      ) > -1
                                                                    : _vm
                                                                        .filterItem
                                                                        .changedItem
                                                                        .isCheckAll,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.checkAllItems()
                                                                  },
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm
                                                                          .filterItem
                                                                          .changedItem
                                                                          .isCheckAll,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          null,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .changedItem,
                                                                            "isCheckAll",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .changedItem,
                                                                            "isCheckAll",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .filterItem
                                                                          .changedItem,
                                                                        "isCheckAll",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "selectAll"
                                                                )
                                                              ) + " "
                                                            ),
                                                            _c("span", {
                                                              staticClass:
                                                                "checkmark",
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._l(
                                                      _vm.filteredItems,
                                                      function (item, i) {
                                                        return _c(
                                                          "label",
                                                          {
                                                            key: i,
                                                            staticClass:
                                                              "checkbox-container",
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .filterItem
                                                                      .changedItem
                                                                      .checkedList,
                                                                  expression:
                                                                    "filterItem.changedItem.checkedList",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "checkbox",
                                                              },
                                                              domProps: {
                                                                value: item,
                                                                checked:
                                                                  Array.isArray(
                                                                    _vm
                                                                      .filterItem
                                                                      .changedItem
                                                                      .checkedList
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm
                                                                          .filterItem
                                                                          .changedItem
                                                                          .checkedList,
                                                                        item
                                                                      ) > -1
                                                                    : _vm
                                                                        .filterItem
                                                                        .changedItem
                                                                        .checkedList,
                                                              },
                                                              on: {
                                                                change: [
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm
                                                                          .filterItem
                                                                          .changedItem
                                                                          .checkedList,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          item,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .changedItem,
                                                                            "checkedList",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .filterItem
                                                                              .changedItem,
                                                                            "checkedList",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .filterItem
                                                                          .changedItem,
                                                                        "checkedList",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.updateCheckallItems()
                                                                  },
                                                                ],
                                                              },
                                                            }),
                                                            _vm._v(
                                                              _vm._s(item) + " "
                                                            ),
                                                            _c("span", {
                                                              staticClass:
                                                                "checkmark",
                                                            }),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "done-filter-button mt-1",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.filterChangedItem()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.$t("done")) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("span", { staticClass: "separator ml-1" }),
                                _c(
                                  "div",
                                  { staticClass: "flex-col pt-1 pl-1" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "remove-button reset-filter-button",
                                        class: {
                                          reset:
                                            _vm.filterItem.resetFilters
                                              .isActive,
                                        },
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.resetFilter()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("resetFilters")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "flex-col flex-1" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "flex-row reverse",
                                  staticStyle: { "align-items": "center" },
                                },
                                [
                                  _vm.isDataLoaded
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "flex-col mr-4 ml-1",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onUiToggle()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              class: [
                                                "flex-row",
                                                "toggler",
                                                _vm.isTableData
                                                  ? "reverse"
                                                  : "",
                                              ],
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex-col flex-1 toggle-text",
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: [
                                                        "fas",
                                                        _vm.isTableData
                                                          ? "text-width"
                                                          : "chart-pie",
                                                      ],
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("div", {
                                                staticClass:
                                                  "flex-col flex-1 toggle-switch",
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("span", { staticClass: "separator ml-1" }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex-col",
                                      staticStyle: {
                                        "align-items": "flex-end",
                                      },
                                    },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.pageSize,
                                              expression: "pageSize",
                                            },
                                          ],
                                          on: {
                                            change: [
                                              function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.pageSize = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              },
                                              _vm.changePageSize,
                                            ],
                                          },
                                        },
                                        _vm._l(
                                          _vm.pageSizeSelection,
                                          function (size) {
                                            return _c(
                                              "option",
                                              {
                                                key: size,
                                                domProps: { value: size },
                                              },
                                              [_vm._v(_vm._s(size) + " ")]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex-col pagesizelebel mr-2",
                                    },
                                    [_vm._v("Page Size:")]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      !_vm.pagingData.totalPageCount
                        ? _c(
                            "div",
                            { staticClass: "ml-4 changelog-table no-data" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("noDataAvailable")) + " "
                              ),
                            ]
                          )
                        : _c("paging", {
                            attrs: { pagingData: _vm.pagingData },
                            on: { "current-page": _vm.modifyContent },
                          }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm.pagingData.totalPageCount
              ? _c(
                  "adam-table",
                  {
                    staticClass: "mr-3 ml-3 changelog-table",
                    domProps: {
                      columns: _vm.columns,
                      data: _vm.data,
                      onRowExpanded: _vm.rowExpanded,
                      hasActions: true,
                    },
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "rowDetails" }, slot: "rowDetails" },
                      [
                        _c("p", [
                          _c("em", [_c("b", [_vm._v("Old Text:")])]),
                          _vm._v(" [[ oldValue ]]"),
                        ]),
                        _c("p", [
                          _c("em", [_c("b", [_vm._v("New Text:")])]),
                          _vm._v(" [[ newValue ]]"),
                        ]),
                        _c("p", [
                          _c("em", [_c("b", [_vm._v("Rationale:")])]),
                          _vm._v(" [[ updComment ]]"),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }